module.exports = __webpack_public_path__ + "img/25.7f41ac55.png";